import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { LocationsEffects } from 'app/state/locations/locations.effects';
import { LocationsReducer } from 'app/state/locations/locations.reducer';

@NgModule({
    declarations: [],
    imports: [StoreModule.forFeature(LocationsReducer), EffectsModule.forFeature([LocationsEffects])],
})
export class LocationsModule {}
